module.exports = __webpack_public_path__ + "static/Cartovera-fe04be24d91036e091ec8a5d3e5fb927.png";